/**
 * Pauses between attempts, in milliseconds, holding at the last value.
 *
 * Unbounded on purpose. This runs on unattended POS terminals, and the thing being waited for is a
 * network that comes back on its own. Capped at 30s so a service that is already struggling is not
 * being polled hard, and so a venue that closes overnight costs two requests a minute.
 */
const RETRY_BACKOFF_MS = [1000, 2000, 4000, 8000, 15_000, 30_000];

export const retryDelay = (attempt: number) =>
  RETRY_BACKOFF_MS[Math.min(attempt, RETRY_BACKOFF_MS.length - 1)];

export const sleep = (ms: number) =>
  new Promise<void>((resolve) => setTimeout(resolve, ms));
